import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { onBeforeMount, reactive, ref, toRefs, watch } from "vue";
//@ts-ignore
import { updateNote as updateNoteAPI } from "@services/publicUserAPI";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { getRealEstateNotes } from "@services/realEstateAPI";
//@ts-ignore
import { showAddFavoritesIcon, showRemoveFavoritesIcons } from "@utils/favoriteUtils";
//@ts-ignore
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
//@ts-ignore
import { useLoggedUserStore } from "@store/LoggedUserStore";
//@ts-ignore
import { useModalStore } from "@store/ModalStore";
//@ts-ignore
import { decodeCookie, encodeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { emptyElem } from "@utils/DOMUtils";
export function useFavourite() {
  var _this = this;
  var state = reactive({
    tempFavoritesIdList: null,
    notes: "",
    disableNotes: true,
    focusNotes: false,
    notesInitialized: false,
    clearTextarea: false,
    curRealEstateId: null
  });
  var loggedUserStore = useLoggedUserStore();
  var publicUserMenuStore = usePublicUserMenuStore();
  var modalStore = useModalStore();
  var textareas = ref({});
  var favoriteIdToDelete = ref(null);
  var handleAddFavorite = id => __awaiter(this, void 0, void 0, function* () {
    if (!id) return;
    try {
      if (!loggedUserStore.isUserLogged) {
        var tempFavorites = [];
        tempFavorites.push(id);
        sessionStorage.setItem("tempFavorites", JSON.stringify(tempFavorites));
      }
      checkIfUserIsLogged();
      yield publicUserMenuStore.addFavorite(id);
      showRemoveFavoritesIcons(id);
      var favCookie = decodeCookie("activeFavCookie");
      // EDIT mailAlertOnFavouriteModal, now it has been shown every 24h even if user already have favourites
      if (favCookie === null) {
        encodeCookie("activeFavCookie", true, 1);
        modalStore.setShowModal(Modals.mailAlertOnFavouriteModal);
      }
    } catch (error) {
      //In this case the user is not logged in!
    }
  });
  var handleRemoveFavorite = function handleRemoveFavorite(id) {
    var withModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!withModal) {
      publicUserMenuStore.removeFavorite(id).then(() => {
        showAddFavoritesIcon(id);
      });
      return;
    }
    modalStore.showModal = Modals.confirmDeleteFavoriteModal;
    favoriteIdToDelete.value = id;
  };
  var removeSingleFavorite = () => __awaiter(this, void 0, void 0, function* () {
    var _a;
    if (!favoriteIdToDelete.value) return;
    try {
      yield publicUserMenuStore.removeFavorite(favoriteIdToDelete.value);
      (_a = document.querySelector("li[data-id='li-article-".concat(favoriteIdToDelete.value, "']"))) === null || _a === void 0 ? void 0 : _a.remove();
      modalStore.showModal = Modals.noModal;
    } catch (e) {
      console.error(e);
    }
  });
  var handleRemoveAllFavorites = function handleRemoveAllFavorites() {
    var withModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!withModal) return;
    modalStore.showModal = Modals.confirmDeleteAllFavoritesModal;
  };
  var removeAllFavorites = () => __awaiter(this, void 0, void 0, function* () {
    try {
      yield publicUserMenuStore.removeFavorites();
      emptyElem("#list-favourites");
      modalStore.showModal = Modals.noModal;
    } catch (e) {
      console.error(e);
    }
  });
  var handleEditNote = id => {
    var _a, _b;
    try {
      checkIfUserIsLogged();
      (_a = document.getElementById("fav-note-".concat(id))) === null || _a === void 0 ? void 0 : _a.classList.add("fav-note-show", "fav-note-editing");
      (_b = document.getElementById("fav-bt-".concat(id))) === null || _b === void 0 ? void 0 : _b.focus();
    } catch (error) {
      //In this case the user is not logged in!
    }
  };
  var updateNote = function updateNote(id) {
    var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var single = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var hideTextArea = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return __awaiter(_this, void 0, void 0, function* () {
      try {
        if (publicUserMenuStore.getFavoriteById(id) === -1) yield handleAddFavorite(id);
        state.clearTextarea = false;
        if (remove) {
          state.notes = "";
          if (single) state.clearTextarea = true;else {
            textareas.value["textarea-".concat(id)].clearTextareaElem();
          }
        }
        var notesValue = single ? state.notes : document.getElementById("fav-bt-".concat(id)).value;
        yield updateNoteAPI(id, notesValue);
        var textAreaElem = document.getElementById("fav-note-".concat(id));
        if (state.notes) textAreaElem === null || textAreaElem === void 0 ? void 0 : textAreaElem.classList.remove("fav-note-editing");else if (!state.notes && hideTextArea) textAreaElem === null || textAreaElem === void 0 ? void 0 : textAreaElem.classList.remove("fav-note-show", "fav-note-editing");
        if (single) state.disableNotes = true;else {
          textareas.value["textarea-".concat(id)].disableTextarea();
        }
      } catch (error) {
        console.error(error);
        //favorite could not been added
        //update error
      }
    });
  };
  var editAndShowButtons = function editAndShowButtons(id, editText) {
    var single = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _a;
    if (editText !== undefined && single) {
      //Updating this variable iff there is just a single textarea
      state.notes = editText;
    }
    try {
      checkIfUserIsLogged();
      (_a = document.getElementById("fav-note-".concat(id))) === null || _a === void 0 ? void 0 : _a.classList.add("fav-note-show", "fav-note-editing");
      if (single) {
        state.disableNotes = false;
        state.focusNotes = true;
      } else {
        textareas.value["textarea-".concat(id)].disableAndFocusTextarea();
      }
    } catch (error) {
      //In this case the user is not logged in!
    }
  };
  var checkIfUserIsLogged = () => {
    if (!loggedUserStore.isUserLogged) {
      modalStore.setShowModal(Modals.loginModal);
      throw "The user must to login if he wants to make this action";
    }
  };
  var openNoteModal = () => {
    try {
      checkIfUserIsLogged();
      modalStore.setShowModal(Modals.noteModal);
    } catch (error) {
      //In this case the user is not logged in!
    }
  };
  var initNotes = realEstateMiniItemId => __awaiter(this, void 0, void 0, function* () {
    state.curRealEstateId = realEstateMiniItemId;
    state.notes = yield getRealEstateNotes(realEstateMiniItemId);
    state.notesInitialized = !!(state.notes && loggedUserStore.isUserLogged);
  });
  // This function should be called when the user logs in
  var saveTempFavorites = () => __awaiter(this, void 0, void 0, function* () {
    var tempFavorites = JSON.parse(sessionStorage.getItem("tempFavorites") || "[]");
    for (var id of tempFavorites) {
      try {
        yield publicUserMenuStore.addFavorite(id);
        showRemoveFavoritesIcons(id);
      } catch (error) {
        // Handle error
      }
    }
    // Clear the temp favorites from session storage
    sessionStorage.removeItem("tempFavorites");
  });
  onBeforeMount(() => {
    watch(() => loggedUserStore.isUserLogged, cur => {
      if (cur) {
        saveTempFavorites();
        state.notesInitialized = false;
        if (!state.curRealEstateId) return;
        initNotes(state.curRealEstateId);
      }
    });
    watch(() => publicUserMenuStore.favoriteIdList, favoriteIdList => {
      var _a;
      if (favoriteIdList.length >= 1 && loggedUserStore.isUserLogged && !state.tempFavoritesIdList) {
        state.tempFavoritesIdList = favoriteIdList;
        favoriteIdList.forEach(id => {
          showRemoveFavoritesIcons(id);
        });
      } else if (favoriteIdList.length >= 0 && loggedUserStore.isUserLogged && state.tempFavoritesIdList) {
        //In this scenario we have added or removed a  favorite, let's sync it!
        state.tempFavoritesIdList = favoriteIdList;
      } else if (favoriteIdList.length === 0 && !loggedUserStore.isUserLogged) {
        (_a = state.tempFavoritesIdList) === null || _a === void 0 ? void 0 : _a.forEach(id => {
          showAddFavoritesIcon(id);
        });
        state.tempFavoritesIdList = null;
      }
    });
    document.addEventListener("init-favorite-event", e => {
      var {
        realEstateIdList
      } = e.detail;
      realEstateIdList.forEach(id => {
        if (!loggedUserStore.isUserLogged) {
          showAddFavoritesIcon(id);
          return;
        }
        //In this scenario the favorite is already in the favoriteIdList
        if (publicUserMenuStore.getFavoriteById(id) >= 0) showRemoveFavoritesIcons(id);else showAddFavoritesIcon(id);
      });
    });
    document.addEventListener("change-favorite-event", e => {
      var {
        realEstateId,
        action
      } = e.detail;
      if (action === "save") {
        handleAddFavorite(realEstateId);
      } else if (action === "delete") {
        handleRemoveFavorite(realEstateId);
      }
    });
  });
  return Object.assign(Object.assign({}, toRefs(state)), {
    textareas,
    handleAddFavorite,
    handleRemoveFavorite,
    handleRemoveAllFavorites,
    handleEditNote,
    updateNote,
    editAndShowButtons,
    openNoteModal,
    initNotes,
    removeSingleFavorite,
    removeAllFavorites
  });
}